import { CssBaseline, ThemeProvider } from "@mui/material";
import type React from "react";
import { szTheme } from "../../theme/theme.ts";

/**
 * Main theme provider for the whole app
 * nothing should be needed to implement here
 * if you need to adjust the theme do so in `theme.ts`
 * @param children
 * @constructor
 */
const SzThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<ThemeProvider noSsr={true} defaultMode="light" theme={szTheme}>
			<CssBaseline />
			{children}
		</ThemeProvider>
	);
};

export default SzThemeProvider;
